/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, RIKEN){
	const a = 'is-active';
	const v = 'is-visible';
	const f = 'is-fixed';

	const createSitemap = () => {
		let $csvPath = '/sitemap/';
		const $output = $('.js-sitemap-output');

		if(location.pathname.indexOf('/en/') !== -1) {
			$csvPath = '/en/sitemap/';
		}
		const req = new XMLHttpRequest();
		req.open('get', $csvPath + 'sitemap.csv', true);
		req.send(null);
		let holidayArr = [];
		req.onload = function(){
			let tmp = req.responseText.split('\n');

			let titleData = tmp[0].split(',');
			let type1Idx = titleData.indexOf('種別');
			let type2Idx = titleData.indexOf('分類');
			let type3Idx = titleData.indexOf('分類URL');
			let type4Idx = titleData.indexOf('カテゴリ');
			let type5Idx = titleData.indexOf('カテゴリURL');
			let type6Idx = titleData.indexOf('ページ');
			let type7Idx = titleData.indexOf('ページURL\r');
			let ulName, ulName_sub;

			// タイトル列削除
			tmp.shift();
			
			tmp.forEach((val, idx) => {
				const data = val.split(',');

				// h2生成
				if(data[type1Idx] !== '' && data[type1Idx] !== undefined) {
					let titHtml = `<h2 class="mod-head04">${data[type1Idx]}</h2>`;
					$output.append(titHtml);
				}
				// 分類
				if(data[type2Idx] !== '' && data[type2Idx] !== undefined) {
					let _tit = data[type2Idx];
					let _url = data[type3Idx];
					let linkHtml = `<h3 class="mod-head05 mt35"><a href="${_url}" class="mod-link01">
					<span class="__txt">${_tit}</span><span class="icon">
					<svg><use xlink:href="/common/svg/sprite.svg#arrow_right2"></use></svg>
					</span></a></h3>`;
					$output.append(linkHtml);
				}
				// カテゴリ
				if(data[type4Idx] !== '' && data[type4Idx] !== undefined) {
					let _tit = data[type4Idx];
					let _url = data[type5Idx];
					let linkHtml = '';
					let prevItem = tmp[idx-1].split(',')[type4Idx];
					let nextItem = tmp[idx+1].split(',')[type4Idx];
					let _target = '_self';
					if(_url.indexOf('//') !== -1) {
						_target = '_blank';
					}

					if(prevItem === '') {
						ulName = 'ul-type01-' + idx;
						linkHtml += '<ul class="pure-g space-u-30 js-ul-type01" data-name="'+ulName+'">';
						if(_url === '') {
							linkHtml += `<li class="pure-u-1 space-u-30-child"><p class="fw_bold fs_20 fs_md_16">${_tit}</p></li>`;
						} else {
							linkHtml += `<li class="space-u-30-child">
							<p class="fw_bold fs_20 fs_md_16">
							<a href="${_url}" target=${_target} class="mod-link05">
							<span class="__txt">${_tit}</span>
							<svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_right2"></use></svg></a></p></li>`;
						}
						$output.append(linkHtml);
					} else {
						if(_url === '') {
							linkHtml += `<li class="pure-u-1 space-u-30-child">
							<p class="fw_bold fs_20 fs_md_16">${_tit}</p></li>`;
							$('ul[data-name="'+ ulName +'"]').append(linkHtml);
						} else {
							linkHtml += `<li class="space-u-30-child">
							<p class="fw_bold fs_20 fs_md_16">
							<a href="${_url}" target=${_target} class="mod-link05">
							<span class="__txt">${_tit}</span><svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_right2"></use></svg></a></p></li>`;
							$('ul[data-name="'+ ulName +'"]').append(linkHtml);
						}
					}

				}
				// ページ
				if(data[type6Idx] !== '' && data[type6Idx] !== undefined) {
					let _tit = data[type6Idx];
					let _url = data[type7Idx];
					let linkHtml = '';
					let prevItem = tmp[idx-1].split(',')[type6Idx];
					let nextItem = tmp[idx+1].split(',')[type6Idx];
					let _target = '_self';
					let blankIcon = '';
					if(_url.indexOf('//') !== -1) {
						_target = '_blank';
						blankIcon = '<svg class="icon"><use xlink:href="/common/svg/sprite.svg#blank"></use></svg>';
					}

					if(prevItem === '') {
						ulName_sub = 'ul-type02-' + idx;
						linkHtml += '<ul class="pure-g js-ul-type02" data-name="'+ ulName_sub +'">';
						linkHtml += `<li><a href="${_url}" target=${_target} class="mod-link03">
						<span class="__txt">${_tit}</span>${blankIcon}</a></li>`;
						$output.append(linkHtml);
					} else {
						if(_url === '') {
							linkHtml += `<li class="pure-u-1">${_tit}</li>`;
							$('ul[data-name="'+ ulName_sub +'"]').append(linkHtml);
						} else {
							linkHtml += `<li><a href="${_url}" target=${_target} class="mod-link03">
							<span class="__txt">${_tit}</span>${blankIcon}</a></li>`;
							$('ul[data-name="'+ ulName_sub +'"]').append(linkHtml);
						}
					}

				}
			});
		};
		return false;
	};

	if($('.js-sitemap-output').length) {
		createSitemap();
	}

})(window.jQuery, window.RIKEN);
